import React, { useState, useEffect } from 'react';
import PartnerLogin from './components/PartnerLogin';
import PartnerDashboard from './components/PartnerDashboard';

function App() {
  const [token, setToken] = useState(localStorage.getItem('pv_token'));
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!token) {
      setChecking(false);
      return;
    }
    // Verify token on mount
    fetch('/api/auth/me', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) throw new Error('Invalid token');
        return res.json();
      })
      .then(data => {
        setUser(data.user);
        setChecking(false);
      })
      .catch(() => {
        localStorage.removeItem('pv_token');
        setToken(null);
        setChecking(false);
      });
  }, [token]);

  const handleLogin = (newToken, userData) => {
    localStorage.setItem('pv_token', newToken);
    setToken(newToken);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('pv_token');
    setToken(null);
    setUser(null);
  };

  if (checking) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a, #1e293b)' }}>
        <div style={{ color: '#64748b', fontSize: '1.1rem' }}>Loading...</div>
      </div>
    );
  }

  if (!token || !user) {
    return <PartnerLogin onLogin={handleLogin} />;
  }

  return <PartnerDashboard user={user} token={token} onLogout={handleLogout} />;
}

export default App;
